import dayjs from "dayjs";
import type {
  BuildBulkAcceptExportInput,
  BulkAcceptExportPayload,
  BulkAcceptExportSkuRow,
  SkuSaleStatus,
} from "./types";

const STATUS_LABEL: Record<SkuSaleStatus, string> = {
  available: "พร้อมจำหน่าย",
  unavailable: "ไม่พร้อมจำหน่าย",
};

export function buildBulkAcceptExportPayload(
  input: BuildBulkAcceptExportInput
): BulkAcceptExportPayload {
  const skuRows: BulkAcceptExportSkuRow[] = [];
  let rank = 0;

  for (const g of input.productGroups) {
    for (const s of g.skus) {
      rank += 1;
      const status = input.skuAvailability[s.key] ?? "available";
      skuRows.push({
        rank,
        productName: g.product_name,
        skuLabel: s.label,
        qty: s.qty,
        statusLabel: STATUS_LABEL[status],
      });
    }
  }

  return {
    factoryName: input.factoryName.trim() || "-",
    exportedAtLabel: dayjs().format("DD/MM/YYYY HH:mm"),
    orderCount: input.orderCount,
    skuCount: input.skuCount,
    totalPieces: input.totalPieces,
    readyToConfirmCount: input.readyToConfirmCount,
    notReadyToConfirmCount: input.notReadyToConfirmCount,
    skuRows,
  };
}

export function bulkAcceptExportFileBaseName(): string {
  return `accept_orders_product_summary_${dayjs().format("YYYYMMDD_HHmmss")}`;
}
